import React from "react";

import "./Creator.css";

export default function Creator() {
  return (
    <div className="Creator">
      <a
        href="https://github.com/VikaKri/weather-with-cats"
        target="_blank"
        rel="noreferrer"
        title="GitHub"
      >
        Open-source code
      </a>{" "}
      by{" "}
      <a
        href="https://www.linkedin.com/in/victoria-krivorotova-759a08195/"
        target="_blank"
        rel="noreferrer"
        title="LinkedIn"
      >
        Vika Krivorotova
      </a>
    </div>
  );
}
